import { css } from '@emotion/react';
import { CSSInterpolation } from '@emotion/serialize';
import { useMemo } from 'react';
import { Theme } from '../theme';
import { useTheme } from '../ThemeProvider';

type StylesObj = Record<string, CSSInterpolation>;
type StylesFn<T> = (theme: Theme) => { [K in keyof T]: T[K] };

/**
 *
 * @param styles an object or functions(theme) where you declare
 * your classnames that contain CSS rules.
 * @returns useStyle hook fn.
 */
export const createStyles = <T extends StylesObj>(
  styles: { [K in keyof T]: T[K] } | StylesFn<T>
): (() => T) => {
  const useStyles = () => {
    const theme = useTheme();

    return useMemo(() => {
      const rawClassNames =
        typeof styles === 'function' ? styles(theme) : styles;

      const classNames: StylesObj = {};

      Object.entries(rawClassNames).forEach(([key, value = {}]) => {
        classNames[key] = css(value);
      });
      return classNames as T;
    }, [theme]);
  };
  return useStyles;
};
